import React, { useState, useEffect, useContext } from 'react';
import { UserContext } from '../components/userContext';
import { useHistory } from 'react-router';
import axios from 'axios';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import { makeStyles, withStyles, lighten } from '@material-ui/core/styles';
import { 
  Button,
  Checkbox,
  CssBaseline,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  InputAdornment,
  IconButton,
  InputBase,
  Menu,
  MenuItem,
  Paper,
  Slider,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
} from '@material-ui/core';
import Rating from '@material-ui/lab/Rating';

import AddBoxRoundedIcon from '@material-ui/icons/AddBoxRounded';
import AddCircleOutlineRoundedIcon from '@material-ui/icons/AddCircleOutlineRounded';
import AddCircleRoundedIcon from '@material-ui/icons/AddCircleRounded';
import AddRoundedIcon from '@material-ui/icons/AddRounded';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import FilterListIcon from '@material-ui/icons/FilterList';
import KeyboardArrowDownRoundedIcon from '@material-ui/icons/KeyboardArrowDownRounded';
import KeyboardArrowUpRoundedIcon from '@material-ui/icons/KeyboardArrowUpRounded';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import SearchRoundedIcon from '@material-ui/icons/SearchRounded';

const useToolbarStyles = makeStyles((theme) => ({
  toolbarContainer: {
    width: 'auto',
    overflowX: 'auto',
    overflowY: 'hidden'
  },
  root: {
    minWidth: 270,
    display: 'flex',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    backgroundColor: 'rgba(26, 26, 26, 0.975)',
  },
  highlight:
    theme.palette.type === 'light'
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    minWidth: '105px',
  },
  arrowDown: {
    width: '38px',
    height: '38px',
    '@media (max-width:750px)': {
      marginRight: '-12px'
    }
  },
  titleArrowClose: {
    '@media (max-width:599px)': {
      display: 'none',
    }
  },
  buttonAdd: {
    width: '38px',
    height: '38px',
    fontSize: 14,
    '& .MuiButton-root': {
      lineHeight: 0,
    }
  },
  grow: {
    flexGrow: 1
  },
  searchForm: {
    display: 'flex', 
    flexDirection: 'row', 
    alignItems: 'center', 
    position: 'relative', 
    justifyContent: 'flex-end', 
    width: '275px',
    '@media (max-width:599px)': {
      width: '100%'
    }
  },
  inputBaseClose: {
    height: '38px',
    width: '38px',
    visibility: 'hidden',
    borderRadius: '19px',
    fontSize: '14px',
    backgroundColor: 'rgba(22, 22, 22, 1)',
    color: theme.palette.text.secondary,
    '& .MuiInputBase-input': {
      padding: '12px',
      height: '100%'
    },
    transition: 'all 0.3s ease',
  },
  inputBaseOpen: {
    width: '100%',
    visibility: 'visible',
    transition: 'all 0.5s ease',
    '& .MuiInputBase-input': {
      paddingRight: '26px',
    },
  },
  searchIconClose: {
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center', 
    position: 'absolute', 
    right: 0, 
    top: 0,
    height: '100%', 
    width: '38px', 
    borderRadius: '19px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(40, 40, 40, 1)'
    }
  },
  searchIconOpen: {
    backgroundColor: 'rgba(22, 22, 22, 1)',
  },
  slider: {
    height: 0
  },
  filterFieldClose: {
    backgroundColor: 'rgba(26, 26, 26, 0.975)',
    opacity: 0,
    display: 'flex',
    height: 0,
  },
  filterFieldOpen: {
    height: 'auto',
    padding: 8,
    opacity: 1,
    borderTop: '1px solid rgba(81, 81, 81, 1)',
    transition: 'opacity 0.5s ease-in',
    '@media (max-width:750px)': {
      marginTop: 4,
      borderTop: 'none',
    }
  },
  filterInput: {
    fontSize: 12,
    display: 'flex',
    alignItems: 'center',
    height: '38px',
    width: '100%',
    borderRadius: '19px',
    fontSize: '14px',
    backgroundColor: 'rgba(22, 22, 22, 1)',
    color: theme.palette.text.secondary,
    '& .MuiInputBase-input': {
      paddingLeft: '12px',
      height: '100%'
    },
    '& p': {
      fontSize: 12,
      paddingRight: 12,
      fontStyle: 'italic'
    },
  },
  playerModeCheck: {
    '& .MuiTypography-body1': {
      fontSize: 12
    }
  },
  gameModeContainer: {
    '& .MuiSvgIcon-root': {
      width: '0.75em',
      height: '0.75em'
    }
  },
  buttonFilter: {
    width: '50%', 
    backgroundColor: 'rgba(255, 255, 255, 0.08)', 
    borderRadius: 0,
  }
}));

const CustomTableToolbar = (props) => {
  const classes = useToolbarStyles();
  const { user, movies, setMovies, showFilteredItems2, setShowFilteredItems2, selected, numSelected, onResetFilter, history } = props;
  const [ searchValue, setSearchValue ] = React.useState("");
  const [ searchField, setSearchField ] = React.useState(false);
  const [ filterField, setFilterField ] = React.useState(false); 
  const [ filterValue, setFilterValue ] = React.useState({genre: '', rating: null, year: null, duration: null});

  const submitSearch = (e) =>{
    e.preventDefault();

    axios.get(`https://backendexample.sanbersy.com/api/data-movie`).then(res => {
      let data = res.data;
      let resMovies = data.map(el => {
        if (Boolean(el.title) === false) el.title = " ";
        if (Boolean(el.image_url) === false) el.image_url = " ";
        if (Boolean(el.genre) === false) el.genre = " ";
        if (Boolean(el.rating) === false) el.rating = 0;
        if (Boolean(el.year) === false) el.year = 0;
        if (Boolean(el.duration) === false) el.duration = 0;
        if (Boolean(el.description) === false) el.description = " ";
        if (Boolean(el.review) === false) el.review = " ";
        let title = el.title.charAt(0).toUpperCase() + el.title.slice(1)
        let genre = el.genre.charAt(0).toUpperCase() + el.genre.slice(1)
        let description = el.description.charAt(0).toUpperCase() + el.description.slice(1)
        let review = el.review.charAt(0).toUpperCase() + el.review.slice(1)
        const { id, image_url, rating, year, duration } = el;
        return { id, title, image_url, genre, rating, year, duration, description, review }
      })

      let filteredTitle = resMovies.filter(movie => movie.title.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1);
      let filteredGenre = resMovies.filter(movie => movie.genre.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1);
      let filteredRating = resMovies.filter(movie => movie.rating.toString() === searchValue.toString());
      let filteredYear = resMovies.filter(movie => movie.year.toString().indexOf(searchValue.toString()) !== -1);
      let filteredDuration = resMovies.filter(movie => movie.duration.toString().indexOf(searchValue.toString()) !== -1);
      let filteredDescription = resMovies.filter(movie => movie.description.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1);
      let filteredReview = resMovies.filter(movie => movie.review.toLowerCase().indexOf(searchValue.toLowerCase()) !== -1);
      let result = [...filteredTitle, ...filteredGenre, ...filteredRating, ...filteredYear, ...filteredDuration, ...filteredDescription,  ...filteredReview];
      setMovies([...new Set(result)]);
    })    
    setShowFilteredItems2(true);    
  }

  const searchChange = (e) => {
    setSearchValue(e.target.value);
  }
  
  // Filter
  const submitFilter = (e) => {
    e.preventDefault();

    axios.get(`https://backendexample.sanbersy.com/api/data-movie`).then(res => {
      let data = res.data;
      let resMovies = data.map(el => {
        if (Boolean(el.title) === false) el.title = " ";
        if (Boolean(el.image_url) === false) el.image_url = " ";
        if (Boolean(el.genre) === false) el.genre = " ";
        if (Boolean(el.rating) === false) el.rating = 0;
        if (Boolean(el.year) === false) el.year = 0;
        if (Boolean(el.duration) === false) el.duration = 0;
        if (Boolean(el.description) === false) el.description = " ";
        if (Boolean(el.review) === false) el.review = " ";
        let title = el.title.charAt(0).toUpperCase() + el.title.slice(1)
        let genre = el.genre.charAt(0).toUpperCase() + el.genre.slice(1)
        let description = el.description.charAt(0).toUpperCase() + el.description.slice(1)
        let review = el.review.charAt(0).toUpperCase() + el.review.slice(1)
        const { id, image_url, rating, year, duration } = el;
        return { id, title, image_url, genre, rating, year, duration, description, review }
      })
      let result = [];

      // Case 1
      if (filterValue.year !== null && filterValue.duration !== null && filterValue.genre !== '') {
        result = resMovies
        .filter(movie => movie.year.toString().indexOf(filterValue.year.toString()) !== -1)
        .filter(movie => movie.duration.toString().indexOf(filterValue.duration.toString()) !== -1)
        .filter(movie => movie.genre.toLowerCase().indexOf(filterValue.genre.toLowerCase()) !== -1)
        console.log('year, duration, genre')
        if (filterValue.rating !== null) {
          result = result.filter(movie => movie.rating.toString() === filterValue.rating.toString())
          console.log('year, duration, genre OK')
        }
      }

      if (filterValue.year !== null && filterValue.duration !== null && filterValue.genre === '') {
        result = resMovies
        .filter(movie => movie.year.toString().indexOf(filterValue.year.toString()) !== -1)
        .filter(movie => movie.duration.toString().indexOf(filterValue.duration.toString()) !== -1)
        console.log('year, duration')
        if (filterValue.rating !== null) {
          result = result.filter(movie => movie.rating.toString() === filterValue.rating.toString())
          console.log('year, duration OK')
        }
      }

      if (filterValue.year !== null && filterValue.duration === null && filterValue.genre !== '') {
        result = resMovies
        .filter(movie => movie.year.toString().indexOf(filterValue.year.toString()) !== -1)
        .filter(movie => movie.genre.toLowerCase().indexOf(filterValue.genre.toLowerCase()) !== -1)
        console.log('year, genre')
        if (filterValue.rating !== null) {
          result = result.filter(movie => movie.rating.toString() === filterValue.rating.toString())
          console.log('year, genre OK')
        }
      }

      if (filterValue.year !== null && filterValue.duration === null && filterValue.genre === '') {
        result = resMovies
        .filter(movie => movie.year.toString().indexOf(filterValue.year.toString()) !== -1)
        console.log('year')
        if (filterValue.rating !== null) {
          result = result.filter(movie => movie.rating.toString() === filterValue.rating.toString())
          console.log('year OK')
        }
      }

      // Case 2
      if (filterValue.year === null && filterValue.duration !== null && filterValue.genre !== '') {
        result = resMovies
        .filter(movie => movie.duration.toString().indexOf(filterValue.duration.toString()) !== -1)
        .filter(movie => movie.genre.toLowerCase().indexOf(filterValue.genre.toLowerCase()) !== -1)
        console.log('duration, genre')
        if (filterValue.rating !== null) {
          result = result.filter(movie => movie.rating.toString() === filterValue.rating.toString())
          console.log('duration, genre OK')
        }
      }

      if (filterValue.year === null && filterValue.duration !== null && filterValue.genre === '') {
        result = resMovies
        .filter(movie => movie.duration.toString().indexOf(filterValue.duration.toString()) !== -1)
        console.log('duration')
        if (filterValue.rating !== null) {
          result = result.filter(movie => movie.rating.toString() === filterValue.rating.toString())
          console.log('duration OK')
        }
      }

      if (filterValue.year === null && filterValue.duration === null && filterValue.genre !== '') {
        result = resMovies
        .filter(movie => movie.genre.toLowerCase().indexOf(filterValue.genre.toLowerCase()) !== -1)
        console.log('genre')
        if (filterValue.rating !== null) {
          result = result.filter(movie => movie.rating.toString() === filterValue.rating.toString())
          console.log('genre OK')
        }
      }

      if (filterValue.year === null && filterValue.duration === null && filterValue.genre === '') {
        result = resMovies
        console.log('none')
        if (filterValue.rating !== null) {
          result = result.filter(movie => movie.rating.toString() === filterValue.rating.toString())
          console.log('none OK')
        }
      }

      setMovies([...result]);
    }) 
    setShowFilteredItems2(true);   
  }

  const filterChange = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    if (name === "genre") setFilterValue({ ...filterValue, [name]: value });
    if (name !== "genre") setFilterValue({ ...filterValue, [name]: parseInt(value) });
  }
  
  const sliderChange = (event, value) => {
    let val = value
    console.log(typeof val)
    setFilterValue({ ...filterValue, rating: val });
    console.log(filterValue.rating)
  }

  const ratingChange = (event) => {
    setFilterValue({ ...filterValue, rating: parseInt(event.target.value * 2)});
  }

  const resetFilter = () => {
    setShowFilteredItems2(false);
    onResetFilter();
  }

  // Tooltip
  const handleDeleteToolbar = () => {
    console.log(selected)
  }

  const handleCreate = () => {
    history.push(`/${user.email}/dashboard/movie-editor/create`);
  }
 
  const handleSearchField = () => {
    setSearchField(!searchField);
  }
  
  const handleFilterField = () => {
    setFilterField(!filterField)
  }

  return (
    <>
      <div className={classes.toolbarContainer}>
        <Toolbar
          className={clsx(classes.root, {
            [classes.highlight]: numSelected > 0,
          })}
        >
          {numSelected > 0 ? (
            <Typography style={{flex: '1 1 100%'}} color="inherit" variant="subtitle1" component="div">
              {numSelected} {numSelected < 2 ? "item selected" : "items selected" }
            </Typography>
          ) : (
            <Typography className={clsx(classes.title, searchField && classes.titleArrowClose)} variant="h6" id="tableTitle" component="div">
              Movies List
            </Typography>
          )}

          {numSelected > 0 ? (
            <Tooltip title="Delete selected items">
              <IconButton onClick={handleDeleteToolbar} aria-label="delete" style={{width: 38, height: 38}}>
                <DeleteRoundedIcon />
              </IconButton>
            </Tooltip>
          ) : (
            <>
              <div className={classes.grow}></div>
              <form onSubmit={submitSearch} className={classes.searchForm}>
                <InputBase 
                  type="text" 
                  title="search by name, genre, release, platform and mode" 
                  placeholder="Type anything..." 
                  title="Search"
                  value={searchValue} 
                  onChange={searchChange} 
                  className={clsx(classes.inputBaseClose, searchField && classes.inputBaseOpen)} 
                />
                <IconButton 
                  onClick={handleSearchField}
                  disableFocusRipple
                  disableRipple
                  className={clsx(classes.searchIconClose, searchField && classes.searchIconOpen)}  
                >
                  <SearchRoundedIcon />
                </IconButton>
              </form>
              <IconButton 
                className={clsx(classes.buttonAdd, searchField && classes.titleArrowClose)}
                onClick={handleCreate}
                disableFocusRipple
                disableRipple
                title="Add New Movie"
              >
                <AddCircleRoundedIcon />
              </IconButton>
              <IconButton 
                className={clsx(classes.arrowDown, searchField && classes.titleArrowClose)}
                onClick={handleFilterField}
                disableFocusRipple
                disableRipple
                title="Filter"
              >
                { filterField ?
                  <KeyboardArrowUpRoundedIcon /> : <FilterListIcon />
                }
              </IconButton>
            </>
          )}
        </Toolbar>
        {showFilteredItems2 && (
          <div style={{display: 'flex', padding: '8px 16px', backgroundColor: 'rgba(26, 26, 26, 0.975)', marginTop: 4}}>
            <div style={{display: 'inline-flex', alignItems: 'center', backgroundColor: '#202020', height: 30, borderRadius: 15, padding: '0px 16px'}}>
              <span>{movies.length} {movies.length > 1 ? "items found" : "item found"}</span>
            </div>
          </div>
        )}
        <form onSubmit={submitFilter} style={{minWidth: 270}}>
          <Grid 
            container 
            className={clsx(classes.filterFieldClose, filterField && classes.filterFieldOpen)}      
          >
            <Grid item xs={12} style={{paddingLeft: '8px', fontSize: '16px'}}>Filter</Grid>
            <Grid item xs={12} lg={6} sm={6} style={{display: 'flex', padding: '8px', alignItems: 'center'}}>
              <InputBase
                fullwidth
                className={classes.filterInput}
                type="text" 
                title="filter by genre" 
                placeholder="Filter by genre" 
                name="genre"
                value={filterValue.genre} 
                onChange={filterChange} 
              />
            </Grid>
            <Grid item xs={12} lg={6} sm={6} style={{display: 'flex', padding: '8px', alignItems: 'center'}}>
              <InputBase
                fullwidth
                className={classes.filterInput}
                type="number"
                title="filter by release year" 
                placeholder="Filter by release year" 
                name="year"
                value={filterValue.year} 
                onChange={filterChange} 
              />
            </Grid>
            <Grid item xs={12} lg={6} sm={6} style={{display: 'flex', padding: '8px', alignItems: 'center'}}>
              <InputBase 
                fullwidth
                className={classes.filterInput}
                type="number" 
                title="filter by duration" 
                placeholder="Filter by duration" 
                // inputProps={{min: 0, max: 10}}
                // min={0}
                // max={10}
                name="duration"
                value={filterValue.duration} 
                onChange={filterChange} 
                endAdornment={<InputAdornment position="end">min</InputAdornment>}
              />
            </Grid>
            <Grid item xs={12} lg={4} sm={6} style={{padding: '8px 12px', alignItems: 'center'}}>
              <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}> 
                <Typography id="discrete-slider" style={{fontStyle: "italic", fontSize: '12px', marginRight: 16}}>
                  Rating 
                </Typography>
                <Rating name="half-rating" value={filterValue.rating/2} precision={0.5} onChange={ratingChange} size="small" />
              </div>
              <Slider
                style={{color: 'rgb(163, 102, 255)'}}
                // aria-labelledby="discrete-slider"
                step={1}
                max={10}
                min={0}
                onChange={sliderChange}
                value={filterValue.rating}
              />
            </Grid>
            <Grid item xs={12} lg={2} style={{padding: '8px', justifyContent: 'center', alignItems: 'center', display: 'flex'}}>
              <Button type="submit" className={classes.buttonFilter}>
                Filter
              </Button>
              &nbsp;
              <Button onClick={resetFilter} className={classes.buttonFilter}>
                Reset
              </Button>
            </Grid>
          </Grid>
        </form>
      </div>
    </>
  );
};

CustomTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const CustomSwitch = withStyles({
  switchBase: {
    color: 'rgba(60, 60, 60, 1)',
    '&$checked': {
      color: '#fff',
    },
    '&$checked + $track': {
      color: 'blue',
      backgroundColor: 'rgba(120, 120, 120, 1)',
    },
  },
  checked: {},
  track: {},
})(Switch);

function CustomTableHead(props) {
  const { classes, onSelectAllClick, movies, order, orderBy, setOrderBy, numSelected, rowCount, onRequestSort, headCells2, setHeadCells2 } = props;
  const [ anchorEl, setAnchorEl ] = React.useState(null);
  const [ hiddenCells, setHiddenCells ] = React.useState('');
  const [ filterSwitch, setFilterSwitch ] = React.useState(["title", "image", "genre", "rating", "year", "duration", "description", "review", "action"]);
  const [ searchFilterValue, setSearchFilterValue ] = React.useState('');
  const [ columnMenu, setColumnMenu ] = React.useState(false);

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const handleOpen = (event) => {
    console.log(event.currentTarget.value);
    setHiddenCells(event.currentTarget.value)
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChangeSwitch = (event) => {
    let name = event.target.name;
    let value = event.target.checked;
    return setHeadCells2(headCells2.map(headCell => headCell.id === name ? {...headCell, isVisible: value} : headCell));
  };

  const searchFilterChange = (event) => {
    setSearchFilterValue(event.target.value);
    setFilterSwitch(["title", "image", "genre", "rating", "year", "duration", "description", "review", "action"].filter((v,i) => v.toLowerCase().indexOf(event.target.value.toLowerCase()) !== -1));
  }

  const hideAllColumn = () => {
    setHeadCells2(headCells2.map(headCell => ({ ...headCell, isVisible: false }) ))
  }

  const showAllColumn = () => {
    setHeadCells2(headCells2.map(headCell => ({ ...headCell, isVisible: true }) ))
  }

  const handleClick = (event) => {
    if (event.target.getAttribute("value") === "unsort") setOrderBy('');
    if (event.target.innerText === "Hide Column") {
      setHeadCells2(headCells2.map(headCell => headCell.id === hiddenCells ? {...headCell, isVisible: false} : headCell));
    }
    if (event.target.innerText === "Show Column") {
      setColumnMenu(true);
    }
    setAnchorEl(null);
  }

  return (
    <>
      <TableHead className={classes.tableHead}>
        <TableRow>
          <TableCell
            align="center"
            className={classes.checkbox}
          >
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === rowCount}
              onChange={onSelectAllClick}
              inputProps={{ 'aria-label': 'select all movies' }}
            />
          </TableCell>
          {headCells2.filter(headCell => headCell.isVisible === true).map((headCell, index) => (
            <TableCell 
              key={headCell.id}
              align={headCell.align}
              padding={headCell.disablePadding ? 'none' : 'normal'}
              sortDirection={orderBy === headCell.id ? order : false}
              classes={{
                root: classes.normalCell,
                sizeSmall: classes.smallCell
              }}
            >
              {headCell.align === "left" && (
                <div className={classes.moreVertContainerLeft}>
                  {headCell.isSorted ?
                    <>
                      <TableSortLabel
                        active={orderBy === headCell.id}
                        direction={orderBy === headCell.id ? order : 'asc'}
                        onClick={createSortHandler(headCell.id)}
                        title={`Sort by ${headCell.label}`}
                      >
                        {headCell.label}
                        {orderBy === headCell.id ? (
                          <span className={classes.visuallyHidden}>
                            {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                          </span>
                        ) : null} 
                      </TableSortLabel>
                      <span style={{flexGrow: 1}}></span>
                      <IconButton title="Menu" value={headCell.id} className={classes.iconButtonVert} style={{marginRight: '-12px'}} onClick={handleOpen}>
                        <MoreVertIcon fontSize="small" className={classes.moreVert} />
                      </IconButton>
                    </>
                  :
                    <>
                      {headCell.label}
                      <span style={{flexGrow: 1}}></span>
                      <IconButton title="Menu" value={headCell.id} className={classes.iconButtonVert} style={{marginRight: '-12px'}} onClick={handleOpen}>
                        <MoreVertIcon fontSize="small" className={classes.moreVert} />
                      </IconButton>
                    </>
                  }
                </div>)
              }

              {headCell.align === "right" && (
                <div className={classes.moreVertContainerRight}>
                  {headCell.isSorted ?
                    <>
                      <TableSortLabel
                        active={orderBy === headCell.id}
                        direction={orderBy === headCell.id ? order : 'asc'}
                        onClick={createSortHandler(headCell.id)}
                        title="Sort"
                      >
                        {headCell.label}
                        {orderBy === headCell.id ? (
                          <span className={classes.visuallyHidden}>
                            {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                          </span>
                        ) : null} 
                      </TableSortLabel>
                      <span style={{flexGrow: 1}}></span>
                      <IconButton title="Menu" value={headCell.id} className={classes.iconButtonVert} style={{marginLeft: '-12px'}} onClick={handleOpen}>
                        <MoreVertIcon fontSize="small" className={classes.moreVert} />
                      </IconButton>
                    </>
                  :
                    <>{headCell.label}</>
                  }
                </div>)
              }

                {headCell.align === "center" && (<>{headCell.label}</>)}
              </TableCell>
          ))}
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            {orderBy !== '' && <MenuItem value="unsort" onClick={handleClick}>Unsort All</MenuItem>}
            <MenuItem value="hide" onClick={handleClick}>Hide Column</MenuItem>
            <MenuItem value="show" onClick={handleClick}>Show Column</MenuItem>
          </Menu>
        </TableRow>
      </TableHead>
      <div className={clsx(classes.switch, {[classes.switchOpen]: columnMenu} )}>
        <FormControl component="fieldset" style={{width: "300px"}}>
          {/* <FormLabel component="legend" style={{cursor: 'default', fontSize: '16px', fontWeight: 400, marginBottom: 8}}>Hide / Show Column</FormLabel> */}
          <div style={{display: 'flex', flexDirection: 'row-reverse', alignItems: 'center'}}>  
            <IconButton 
              style={{textAlign: 'right', width: 28, height: 28, padding: 8, marginRight: '-8px'}}
              onClick={() => setColumnMenu(false)}
            >
              <CloseRoundedIcon fontSize='small' />
            </IconButton>
            <span style={{fontSize: '14px', flexGrow: 1, fontWeight: 400}}>Hide / Show Column</span>
          </div>
          <FormGroup>
            <TextField className={classes.searchSwitch} 
              type="text"
              label="Find Column" 
              placeholder="Column Title" 
              value={searchFilterValue} 
              onChange={searchFilterChange} 
            />
            <Grid container style={{marginBottom: 12}}>
              {filterSwitch.map((text, index) => (
                <Grid item sm={6}>
                  <FormControlLabel
                    control={<CustomSwitch checked={headCells2[index].isVisible} onChange={handleChangeSwitch} name={text} />}
                    label={text}
                  />
                </Grid>
              ))}
            </Grid>
            <Grid container style={{marginBottom: 12}}>
              <Grid item sm={6}>
                <Button fullWidth variant="text" style={{borderRadius: 0}} onClick={hideAllColumn}>
                  Hide All
                </Button>
              </Grid>
              <Grid item sm={6}>
                <Button fullWidth variant="text" style={{borderRadius: 0}} onClick={showAllColumn}>
                  Show All
                </Button>
              </Grid>  
            </Grid>
          </FormGroup>
        </FormControl>
      </div>
    </>
  );
}

CustomTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  paper: {
    minWidth: 270,
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  sortMobileContainer: {
    display: 'none',
    alignItems: 'center', 
    padding: '8px', 
    backgroundColor: 'rgba(26, 26, 26, 0.975)',
    marginBottom: 4,
    // marginTop: 4,
    // borderTop: '1px solid rgba(81, 81, 81, 1)',
    // marginTop: 4,
    '@media (max-width:750px)': {
      display: 'flex', 
    }
  },
  sortMobile: {
    display: 'flex',
    alignItems: 'center',
    height: 48,
    padding: 8, 
    '& .Mui-focused': {
      color: theme.palette.text.secondary
    },
    '& .MuiFormControl-marginNormal': {
      marginTop: 8
    },
    '& .MuiFormControl-root': {
      width: '100%',
    },
    '& .MuiInputBase-root': {
      height: 42,
      lineHeight: '1rem'
    },
    '& .MuiOutlinedInput-root': {
      borderRadius: '21px'
    },
    '& .MuiInputLabel-outlined': {
      transform: 'translate(14px, 13px) scale(1)'
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      transform: 'translate(14px, -6px) scale(0.75)'
    },
  },
  moreVertContainerLeft: {
    display: 'flex',
    '&:hover .MuiIconButton-root': {
      visibility: 'visible'
    },
    '& .MuiTableSortLabel-root.MuiTableSortLabel-active.MuiTableSortLabel-root.MuiTableSortLabel-active .MuiTableSortLabel-icon': {
      color: 'rgb(163, 102, 255)'
    }
  },
  moreVertContainerRight: {
    display: 'flex',
    flexDirection: 'row-reverse',
    '&:hover .MuiIconButton-root': {
      visibility: 'visible'
    },
    '& .MuiTableSortLabel-root.MuiTableSortLabel-active.MuiTableSortLabel-root.MuiTableSortLabel-active .MuiTableSortLabel-icon': {
      color: 'rgb(163, 102, 255)'
    } 
  },
  iconButtonVert: {
    width: 20,
    height: 20,
    visibility: 'hidden'
  },
  moreVert: {
    fontSize: '0.75em',
    color: theme.palette.text.secondary,
  },
  table: {
    position: 'relative',
    minWidth: 1050,
    minHeight: 400,
    // marginTop: 4,
    '& tbody, tr':{
      backgroundColor: 'rgba(26, 26, 26, 0.975)'
    },
    '& .action-button': {
      color: theme.palette.text.secondary,
      width: 38,
      height: 38
    },
    '@media (max-width:750px)': {
      display: 'block',
      minWidth: 270,
      '& thead': {
        display: 'none'
      },
      '& tbody, tr, th, td': {
        display: 'block',
        width: '100%',
      },
      '& tbody':{
        backgroundColor: 'transparent'
      },
      '& tbody tr':{
        marginBottom: '4px',
      },
      '& th, td': {
        textAlign: 'left',
        // paddingLeft: '30%',
        position: 'relative',
        border: 'none'
      },
      '& th, td:first-child': {
        textAlign: 'center',
        fontSize: '18px',
        width: '100%',
        textTransform: 'capitalize',
        fontWeight: 700,
        // padding: '0 16px'
      },
      '& td:before': {
        display: 'block',
        content: 'attr(data-label)',
        // position: 'absolute',
        left: 0,
        width: '100%',
        textAlign: 'left',
        fontStyle: 'italic',
        fontWeight: 700,
        color: theme.palette.text.secondary,
      },      
    }
  },
  imageCell: {
    width: 104,
    '@media (max-width:750px)': {
      width: '100%'
    }
  },
  image: {
    display: 'block',
    margin: 'auto',
    borderRadius: '5px',
    width: 'auto',
    maxWidth: '80px', 
    minHeight: '100px', 
    maxHeight: '120px', 
    objectFit: 'cover', 
    '@media (max-width:750px)': {
      width: '100%',
      maxWidth: '100%'
    }
  },
  visuallyHidden: {
    border: 0,
    padding: 0,
    height: 15,
    fontSize: '10px',
    fontWeight: 100,
    fontStyle: 'italic',
    color: 'rgb(163, 102, 255)',
    lineHeight: '15px',
    position: 'absolute',
    top: 18,
    width: '100px',
  },
  normalCell: {
    padding : '12px',
    '@media (max-width:750px)': {
      padding: '8px 16px'
    }
  },
  smallCell: {
    padding : '8px',
    '@media (max-width:750px)': {
      padding: '5px 16px'
    }
  },
  checkbox: {
    padding: '0 0 0 4px',
    width: 46,
    '& .MuiSvgIcon-root': {
      color: 'rgb(144, 144, 144)'
    },
    '@media (max-width:750px)': {
      padding: 0,
    },
  },
  pagination: {
    backgroundColor: 'rgba(26, 26, 26, 0.975)',
    '& .MuiTablePagination-toolbar': {
      paddingLeft: 16,
      paddingRight: 16,
    },
    '& .MuiSelect-selectMenu': {
      minHeight: 0
    },
    '& .MuiInputBase-input': {
      padding: '10px 24px 10px 0px'
    },
    '& .MuiSelect-nativeInput': {
      top: 0
    },
    '@media (max-width:750px)': {
      '& .MuiTablePagination-selectRoot': {
        margin: '0px 8px'
      },
      '& .MuiTablePagination-actions': {
        marginLeft: '8px'
      },
      '& .MuiIconButton-root': {
        padding: '8px'
      }
    }
  },
  switch: {
    // display: 'none',
    position: 'absolute',
    top: 48.5,
    left: '-150%',
    zIndex: theme.zIndex.tooltip,
    backgroundColor: '#202020',
    boxShadow: theme.shadows[10],
    borderRadius: 4,
    padding: '8px 16px',
    transition: 'all 1s ease',
    '& .MuiSwitch-track': {
      opacity: 1,
      backgroundColor: 'rgba(40, 40, 40, 1)'
    },
    '& .MuiSwitch-root': {
      height: 36,
      // '& .MuiSwitch-switchBase': {
      //   top: '0px',
      // },  
      '& .MuiSwitch-thumb': {
        height: 18,
        width: 18
      },
    },
  },
  switchOpen: {
    // display: 'block',
    left: 8,
    '@media (max-width:750px)': {
      display: 'none'
    }
  },
  searchSwitch: {
    '& .Mui-focused': {
      color: 'rgb(163, 102, 255)'
    },
    marginBottom: 12,
    '& .MuiInput-underline:after': {
      borderBottomColor: 'rgb(163, 102, 255)',
    },
    '& .MuiInput-root': {
      color: 'white',
      foontWeight: 300
    }
  }
}));

export default function MoviesTable() {
  const classes = useStyles();
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('rating');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const {
    user,
    movies, 
    setMovies,
    fetchMovies,
    setFetchMovies,
    curIdMovies,
    setCurIdMovies,
    showFilteredItems2, 
    setShowFilteredItems2,
    headCells2, 
    setHeadCells2,
  } = useContext(UserContext);
  let history = useHistory();

  useEffect(() => {
    const fetchData = async () => {
      const result = await axios.get(`https://backendexample.sanbersy.com/api/data-movie`); 
      setMovies(result.data.map((el) => { 
        if (Boolean(el.title) === false) el.title = " ";
        if (Boolean(el.image_url) === false) el.image_url = " ";
        if (Boolean(el.genre) === false) el.genre = " ";
        if (Boolean(el.rating) === false) el.rating = 0;
        if (Boolean(el.year) === false) el.year = 0;
        if (Boolean(el.duration) === false) el.duration = 0;
        if (Boolean(el.description) === false) el.description = " ";
        if (Boolean(el.review) === false) el.review = " ";
        let title = el.title.charAt(0).toUpperCase() + el.title.slice(1)
        let genre = el.genre.charAt(0).toUpperCase() + el.genre.slice(1)
        let description = el.description.charAt(0).toUpperCase() + el.description.slice(1)
        let review = el.review.charAt(0).toUpperCase() + el.review.slice(1)
        const { id, image_url, rating, year, duration } = el;
        return { id, title, image_url, genre, rating, year, duration, description, review }
      }));
      console.log(movies);
    }
    if (fetchMovies) {
      fetchData();
      setFetchMovies(false);
    }
  },[fetchMovies]);

  const handleEdit = (event) => { 
    let edId = parseInt(event.currentTarget.value);
    history.push(`/${user.email}/dashboard/movie-editor/edit/${edId}`);
  }

  const handleDelete = (event) => {
    let delId = parseInt(event.target.value); 
    axios.delete(`https://backendexample.sanbersy.com/api/data-movie/${delId}`).then(() => {
      setFetchMovies(true);
    }); 
  }

  function truncateString(str, num) {
    if (str === null) return '';
    if (str.length <= num) return str;
    return str.slice(0, num) + '...';
  }
  
  const descendingComparator = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) return -1;
    if (b[orderBy] > a[orderBy]) return 1;
    return 0;
  }

  const getComparator = (order, orderBy) => {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function stableSort(array, comparator) {
    console.log(array);
    const stabilizedThis = array.map((el, index) => [el, index]);
    console.log(stabilizedThis);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }
  
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleResetFilter = () => {
    setFetchMovies(true);
  }

  const handleSortOrderBy = (event) => {
    console.log(event.target.value)
    setOrderBy(event.target.value)
  }

  const handleSortDirection = (event) => {
    setOrder(event.target.value)
  }

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = movies.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) newSelected = newSelected.concat(selected, id);
    if (selectedIndex === 0) newSelected = newSelected.concat(selected.slice(1));
    if (selectedIndex === selected.length - 1) newSelected = newSelected.concat(selected.slice(0, -1));
    if (selectedIndex > 0) newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    console.log(event.target.value);
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, movies.length - page * rowsPerPage);

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <CustomTableToolbar 
          history={history}
          user={user}
          selected={selected}
          numSelected={selected.length} 
          onResetFilter={handleResetFilter} 
          movies={movies} 
          setMovies={setMovies} 
          showFilteredItems2={showFilteredItems2} 
          setShowFilteredItems2={setShowFilteredItems2} 
        />
        <TableContainer style={{marginTop: 4}}>
          <Grid container className={classes.sortMobileContainer}>
            <Grid item xs={12} style={{fontSize: '16px', padding: '0px 8px 8px 8px'}}>Sort</Grid>
            <Grid item xs={6} className={classes.sortMobile}>
              <TextField
                select
                variant="outlined"
                margin="normal"
                label="Sort By"
                onChange={handleSortOrderBy}
                value={orderBy}
              >
                {orderBy !== '' && <MenuItem value="">Unsort All</MenuItem>}
                <MenuItem value="title">Title</MenuItem>
                <MenuItem value="genre">Genre</MenuItem>
                <MenuItem value="rating">Rating</MenuItem>
                <MenuItem value="year">Release Year</MenuItem>
                <MenuItem value="duration">Duration</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={6} className={classes.sortMobile}>
              <TextField
                select
                variant="outlined"
                margin="normal"
                label="Sort Direction"
                onChange={handleSortDirection}
                value={order}
              >
                <MenuItem value="asc">Ascending</MenuItem>
                <MenuItem value="desc">Descending</MenuItem>
              </TextField>
            </Grid>
          </Grid>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size={dense ? 'small' : 'medium'}
            aria-label="custom table"
          >
            <CustomTableHead
              classes={classes}
              movies={movies}
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              setOrderBy={setOrderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={movies.length}
              headCells2={headCells2}
              setHeadCells2={setHeadCells2}
            />
            <TableBody>
              {stableSort(movies, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((movie, index) => {
                  const isItemSelected = isSelected(movie.id);
                  const labelId = `custom-table-checkbox-${index}`;

                  return (
                    <TableRow
                      hover
                      // onClick={(event) => handleClick(event, game.title)}
                      // role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={movie.id}
                      selected={isItemSelected}
                    >
                      <TableCell 
                        align="center"
                        className={classes.checkbox}
                      >
                        <Checkbox
                          onClick={(event) => handleClick(event, movie.id)}
                          checked={isItemSelected}
                          inputProps={{ 'aria-labelledby': labelId }}
                        />
                      </TableCell>

                      {headCells2[0].isVisible && (
                        <TableCell 
                          align="left"
                          data-label="Title"
                          component="th" 
                          id={labelId} 
                          scope="row" 
                          title={movie.title}
                          classes={{
                            root: classes.normalCell,
                            sizeSmall: classes.smallCell
                          }}
                        >
                          {truncateString(movie.title, 35)}
                        </TableCell>
                      )}

                      {headCells2[1].isVisible && (
                        <TableCell 
                          className={classes.imageCell}
                          align="center"
                          classes={{
                            root: classes.normalCell,
                            sizeSmall: classes.smallCell
                          }}
                        >
                          <img 
                            className={classes.image}
                            src={movie.image_url}
                            alt="Image"
                          />  
                        </TableCell>
                      )}
                      
                      {headCells2[2].isVisible && (
                        <TableCell 
                          data-label="Genre"
                          align="left"
                          classes={{
                            root: classes.normalCell,
                            sizeSmall: classes.smallCell
                          }}
                        >
                          {movie.genre}
                        </TableCell>
                      )}

                      {headCells2[3].isVisible && (
                        <TableCell 
                          data-label="Rating"
                          align="right"
                          classes={{
                            root: classes.normalCell,
                            sizeSmall: classes.smallCell
                          }}
                        >
                          {movie.rating}
                        </TableCell>
                      )}

                      {headCells2[4].isVisible && (
                        <TableCell 
                          style={{minWidth: 110}}  
                          data-label="Release Year"
                          align="right"
                          classes={{
                            root: classes.normalCell,
                            sizeSmall: classes.smallCell
                          }}
                        >
                          {movie.year}
                        </TableCell>
                      )}

                      {headCells2[5].isVisible && (
                        <TableCell 
                          data-label="Duration"
                          align="right"
                          classes={{
                            root: classes.normalCell,
                            sizeSmall: classes.smallCell
                          }}
                        >
                          {movie.duration} mins
                        </TableCell>
                      )}

                      {headCells2[6].isVisible && (
                        <TableCell 
                          data-label="Description"
                          align="justify" 
                          title={movie.description}
                          classes={{
                            root: classes.normalCell,
                            sizeSmall: classes.smallCell
                          }}
                        >
                          {truncateString(movie.description, 200)}
                        </TableCell>
                      )}

                      {headCells2[7].isVisible && (
                        <TableCell 
                          data-label="Review"
                          align="left" 
                          title={movie.review}
                          classes={{
                            root: classes.normalCell,
                            sizeSmall: classes.smallCell
                          }}
                        >
                          {truncateString(movie.review, 40)}
                        </TableCell>
                      )}
                      
                      {headCells2[8].isVisible && (
                        <TableCell align="center" padding='none' style={{minWidth: 100, textAlign: 'center'}}>
                          <IconButton 
                            className="action-button"
                            onClick={handleEdit}
                            value={movie.id}
                          >
                            <EditRoundedIcon fontSize='medium' />
                          </IconButton>
                          <IconButton 
                            className="action-button"
                            onClick={handleDelete}
                            value={movie.id}
                          >
                            <DeleteRoundedIcon fontSize='medium' />
                          </IconButton>
                        </TableCell>
                      )}
                    </TableRow>
                  );
                })}
              {movies.length === 0 && (
                <TableRow style={{ height: 350 }}>
                  <TableCell></TableCell>
                  {headCells2.map(v => v.isVisible && <TableCell></TableCell>)}
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          className={classes.pagination}
          labelRowsPerPage='Rows per page :'
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={movies.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
      <FormControlLabel
        control={<Switch checked={dense} onChange={handleChangeDense} />}
        label="Dense padding"
      />
    </div>
  );
}